var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecvronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.64062C6.73958 8.64062 6.5026 8.53646 6.28906 8.32812L0.34375 2.24219C0.255208 2.15885 0.1875 2.0651 0.140625 1.96094C0.0989583 1.85156 0.078125 1.73438 0.078125 1.60938C0.078125 1.4375 0.117188 1.28125 0.195312 1.14062C0.278646 1 0.388021 0.890625 0.523438 0.8125C0.658854 0.729167 0.8125 0.6875 0.984375 0.6875C1.23438 0.6875 1.45312 0.78125 1.64062 0.96875L7.38281 6.85156H6.625L12.3594 0.96875C12.5469 0.78125 12.7656 0.6875 13.0156 0.6875C13.1875 0.6875 13.3411 0.729167 13.4766 0.8125C13.612 0.890625 13.7188 1 13.7969 1.14062C13.8802 1.28125 13.9219 1.4375 13.9219 1.60938C13.9219 1.85417 13.8333 2.0651 13.6562 2.24219L7.71094 8.32812C7.61198 8.43229 7.5026 8.51042 7.38281 8.5625C7.26302 8.61458 7.13542 8.64062 7 8.64062Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecvronDown);
export default __webpack_public_path__ + "static/media/checvronDown.23b52294eb694608cd4f0460d63a2990.svg";
export { ForwardRef as ReactComponent };